// extracted by mini-css-extract-plugin
export default {"content":"WelcomeText_content__rhIjR","innerContent":"WelcomeText_innerContent__g1iDv","lessSpace":"WelcomeText_lessSpace__lunPY"};